import React from "react";
import { RadialChart } from "react-vis";

const Graph = (props) => {
    const givex = [];
    const futura = [];
    const dotdigital = [];

    if (props.givex && props.givex.success) {
        givex.push(
            {
                angle: props.givex.success,
                label: `${props.givex.success} Success`,
            },
            { 
                angle: props.givex.failed, 
                label: `${props.givex.failed} Failed` 
            }
        );
    }

    if (props.futura && props.futura.success) {
        futura.push(
            {
                angle: props.futura.success,
                label: `${props.futura.success} Success`,
            },
            {
                angle: props.futura.failed,
                label: `${props.futura.failed} Failed`,
            }
        );
    }

    if (props.dotdigital && props.dotdigital.success) {
        dotdigital.push(
            {
                angle: props.dotdigital.success,
                label: `${props.dotdigital.success} Success`,
            },
            {
                angle: props.dotdigital.failed,
                label: `${props.dotdigital.failed} Failed`,
            }
        );
    }

    const handleValueClick = (value, name) => {
        console.log(value.color);
        console.log(name);
        const details = {
            type: `${name}_api`,
            column: "status",
            token: value.color == 0 ? "failed" : "success",
            endPoint: "api"
        };
        props.apiStatsFunction(details);
    };

    const colors = ["#ff8b94", "#00d5a6"];
    const diamention = 300;

    return (
        <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "20px"}}>
            {givex.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">Givex</h3>
                    <RadialChart
                        name="givex"
                        data={givex}
                        width={diamention}
                        height={diamention}
                        showLabels
                        labelsRadiusMultiplier={1.1}
                        colorRange={colors}
                        animation
                        onValueClick={(value) => handleValueClick(value, "givex")}
                    />
                </div>
            )}
            {futura.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">Futura</h3>
                    <RadialChart
                        name="futura"
                        data={futura}
                        width={diamention}
                        height={diamention}
                        showLabels
                        labelsRadiusMultiplier={1.1}
                        colorRange={colors}
                        animation
                        onValueClick={(value) => handleValueClick(value, "futura")}
                    />
                </div>
            )}
            {dotdigital.length > 0 && (
                <div style={{ flex: 1 }}>
                    <h3 className="sub-title text--muted">DotDigital</h3>
                    <RadialChart
                        name="dotdigital"
                        data={dotdigital}
                        width={diamention}
                        height={diamention}
                        showLabels
                        labelsRadiusMultiplier={1.1}
                        colorRange={colors}
                        animation
                        onValueClick={(value) => handleValueClick(value, "dotdigital")}
                    />
                </div>
            )}
        </div>
    );
};

export default Graph;
